/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const Root = styled(Box)(() => ({
  position: 'absolute',
  zIndex: 5,
  top: 10,
  left: 0,
  pointerEvents: 'none',
  width: '100%',
}));

export {Root as XAxisRoot};
